import { Injectable } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private toastr: ToastrService) {}

  success(message: string, title: string = '') {
    this.show('success', message, title);
  }

  error(message: string, title: string = '') {
    this.show('error', message, title);
  }

  warning(message: string, title: string = '') {
    this.show('warning', message, title);
  }

  info(message: string, title: string = '') {
    this.show('info', message, title);
  }

  private show(type: string, message: string, title: string) {
    if (type === 'error') {
      type = 'red';
    }

    const icon =
      type === 'success'
        ? 'fa fa-check'
        : type === 'red'
        ? 'fa fa-times'
        : type === 'warning'
        ? 'fa fa-exclamation-triangle'
        : type === 'info'
        ? 'fa fa-info-circle'
        : '';

    this.toastr.show(
      `<span class="alert-icon ${icon}" data-notify="icon"></span> <div class="alert-text"</div> <span class="alert-title" data-notify="title">${title}</span> <span data-notify="message">${message}</span></div>`,
      '',
      {
        timeOut: 3000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: `ngx-toastr alert alert-dismissible alert-${type} alert-notify`,
      }
    );
  }


  showNotification(type, titulo, mensaje, icon) {

    //TODO: Iconos generales
    //fas fa-times para el error
    //fas fa-check cuando todo esta bien
    //fas fa-exclamation cuando hay una advertencia

    if (type === 'danger') { type = 'red' }

    this.toastr.show(
      `<span class="alert-icon ${icon}" data-notify="icon"></span> <div class="alert-text"</div> <span class="alert-title" data-notify="title">${titulo}</span> <span data-notify="message">${mensaje}</span></div>`,
      '',
      {
        timeOut: 3000,
        closeButton: true,
        enableHtml: true,
        tapToDismiss: false,
        titleClass: 'alert-title',
        positionClass: 'toast-top-center',
        toastClass: `ngx-toastr alert alert-dismissible alert-${type} alert-notify`,
      }
    );
  }
}
